module.exports = __webpack_public_path__ + "img/EWMA-District-Logo-Transparent@2x.2a4a163f.png";